import useApi from "../../api/useApi";

const useStandService = () => {

  const {api} = useApi()

  const userShow = (callbackSuccess, callbackValidationErrors, standId) => {
    return api(
      'get',
      'user/stand/' + standId,
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useStandService::userShow: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  const userShowCollection = (callbackSuccess, callbackValidationErrors) => {
    return api(
      'get',
      'user/stands',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useStandService::userShowCollection: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  const userUpdate = (callbackSuccess, callbackValidationErrors, standId, data) => {
    return api(
      'post',
      'user/stand/' + standId + '/update',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useStandService::userUpdate: ${error?.message || JSON.stringify(error)}`)},
      data,
    )
  }

  const userShowManager = (callbackSuccess, callbackValidationErrors, id, callbackFailed) => {
    return api(
      'get',
      'user/stand/' + id + '/management/show',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      (error) => callbackFailed(error),
    )
  }

  const userStore = (callbackSuccess, callbackValidationErrors, modelId, data) => {
    return api(
      'post',
      'user/stand/store',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useStandService::userStore: ${error?.message || JSON.stringify(error)}`)},
      data,
    )
  }

  const filteredShow = (callbackSuccess, callbackValidationErrors, data) => {
    return api(
      'post',
      'stands/filtered',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useStandService::filteredShow: ${error?.message || JSON.stringify(error)}`)},
      data,
    )
  }

  const show = (callbackSuccess, callbackValidationErrors, slug, callbackFailed) => {
    return api(
      'get',
      'stand/show/' + slug,
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      (error) => callbackFailed(error),
    )
  }

  const userDelete = (callbackSuccess, callbackValidationErrors, id) => {
    return api(
      'post',
      'user/stand/' + id + '/delete',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useStandService::userDelete: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  return {
    objectType:'stand',
    userShow,
    userShowCollection,
    userShowManager,
    userUpdate,
    userStore,
    filteredShow,
    show,
    userDelete,
  }
}

export default useStandService
